import { ModuleWithProviders } from '@angular/core';
import {
    Routes,
    RouterModule,
    PreloadAllModules,
} from '@angular/router';
import { LoginComponent } from '../public/login/login.component';
import { LoginDeutscheDienstradComponent } from '../public/login-dd/login-dd.component';
import { publicGuard, protectedGuard } from 'ngx-auth';
import { ForgotPasswordComponent } from '../public/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../public/reset-password/reset-password.component';
import { ErrorPageComponent } from '../public/error-page/error-page.component';

const routes: Routes = [
    {
        path: 'admin',
        canActivate: [protectedGuard],
        loadChildren: () =>
            import('./admin/system-admin.module').then(
                (m) => m.SystemAdminModule
            ),
        data: { preload: false },
    },
    {
        path: 'login',
        canActivate: [publicGuard],
        component: LoginComponent,
    },
    {
        path: 'unilogin',
        component: LoginDeutscheDienstradComponent,
    },
    {
        path: 'password',
        canActivate: [publicGuard],
        children: [
            {
                path: 'forgot-password',
                canActivate: [publicGuard],
                component: ForgotPasswordComponent,
            },
            {
                path: 'reset',
                canActivate: [publicGuard],
                component: ResetPasswordComponent,
            },
        ],
    },
    {
        path: '',
        redirectTo: '/admin/dashboard',
        pathMatch: 'prefix',
    },
    {
        path: 'error/:errorCode',
        component: ErrorPageComponent,
    },
    {
        path: '**',
        redirectTo: '/error/404'
    },
];

export const SystemAdminRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(
    routes,
    {
        preloadingStrategy: PreloadAllModules,
    }
);
